import { render, staticRenderFns } from "./XLSXInput.vue?vue&type=template&id=35965d1b&scoped=true&"
import script from "./XLSXInput.vue?vue&type=script&lang=js&"
export * from "./XLSXInput.vue?vue&type=script&lang=js&"
import style0 from "./XLSXInput.vue?vue&type=style&index=0&id=35965d1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35965d1b",
  null
  
)

export default component.exports